module.exports = __webpack_public_path__ + "img/خبری.09575369.jpg";